import VueClipboard from 'vue-clipboard2';
export default function(Vue) {
  VueClipboard.config.autoSetContainer = true;
  Vue.use(VueClipboard);
}
